import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LandingPage from './LandingPage';
import LoginPage from './LoginPage';
import SignUp from './SignUp';
import Dashboard from './Dashboard';
import Cameras from './Cameras'
import History from './History';
import Footage from './Footage';
import Profile from './Profile';
import Settings from './Settings';
import Team from './Team';
import { NotificationProvider } from './NotificationProvider';


function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cameras" element={<Cameras />} />
        <Route path="/history" element={<History />} />
        <Route path="/footage" element={<Footage />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/team" element={<Team />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <Router>
      <NotificationProvider>
        <AnimatedRoutes />
      </NotificationProvider>
    </Router>
  );
}

export default App;
